var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:[ _vm.iconType ? _vm.iconType : 'fas' ,("fa-" + _vm.icon)]})])}
var staticRenderFns = []

export { render, staticRenderFns }